// extracted by mini-css-extract-plugin
export var cardHeader = "_eo-0";
export var reorderHandle = "_eo-3";
export var titleArea = "_eo-1";
export var titleAreaWithHandle = "_eo-2";